import { render, staticRenderFns } from "./WorkflowActionSendEmail.vue?vue&type=template&id=5962d658&scoped=true&"
import script from "./WorkflowActionSendEmail.vue?vue&type=script&lang=ts&"
export * from "./WorkflowActionSendEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5962d658",
  null
  
)

export default component.exports